import { BrowserRouter } from "react-router-dom";
import { Notifications } from "@mantine/notifications";
import AppRoutes from "./routes";
import { ScrollToTop } from "./components/common/ScrollToTop";

function App() {
  return (
    <>
      <Notifications position="bottom-right" zIndex={1000} />
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </>
  );
}

export default App;
